import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { logoutAdmin, loginAdmin } from "../../store/actions";
import { getCookie, checkCookie } from "../Common";
import db from "../../firebase";
import AdminLogin from "./AdminLogin";
import AdminPanelHeader from "./AdminPanelHeader";
import AdminPanelSidebar from "./AdminPanelSidebar";
import { collection, getDocs, query, where } from "firebase/firestore";
import AdminDashboard from "./AdminDashboard";
import Box from "@mui/material/Box";
import { useState } from "react";
import SuccessMsg from "./SuccessMsg";

export default function AdminPanel() {
  const dispatch = useDispatch();
  const loggedAdmin = useSelector((state) => state.loggedAdmin);
  const adminSuccessMsg = useSelector((state) => state.adminSuccessMsg);

  const [currentScreenWidth, setCurrentScreenWidth] = useState(
    window.outerWidth
  );
  
  useEffect(() => {
    window.addEventListener("resize", () =>
      setCurrentScreenWidth(window.outerWidth)
    );
  }, []);

  // on load functions
  useEffect(() => {
    async function checkToken() {
      const q = query(
        collection(db, "user_data"),
        where("token", "==", getCookie("admin_active"))
      );
      const collectionnn = await getDocs(q);
      collectionnn.forEach((docc) => {
        if (docc.data().role === "admin") {
          dispatch(loginAdmin());
        } else {
          dispatch(logoutAdmin());
        }
      });
    }
    checkCookie("admin_active") && checkToken();
  }, [dispatch]);

  return loggedAdmin ? (
    <>
      <AdminPanelHeader />
      <Box sx={{ height: "calc(100vh - 65px)" }}>
        <AdminPanelSidebar currentScreenWidth={currentScreenWidth} />
        <AdminDashboard currentScreenWidth={currentScreenWidth} />
      </Box>
      {adminSuccessMsg !== "" && <SuccessMsg />}
    </>
  ) : (
    <AdminLogin />
  );
}
